module.exports = __webpack_public_path__ + "static/media/thirteenth_columbus_regional_hospital1.116359b4.jpg";